export enum EnumCTEsTabs {
  LISTAGEM_CTES = "listagem_ctes",
  FATURAMENTO_CTES = "invoicing_ctes",
  ESTOQUE_CTES = "stock_ctes"
}

export enum EnumCTEsTabsPage {
  LISTAGEM_CTES = "0",
  FATURAMENTO_CTES = "1",
  ESTOQUE_CTES = "2"
}
export interface CTeData {
  data: Array<CTeState>;
}
export interface CTeState {
  id: string;
  documentEbl: string;
  documentNumberPayer: string;
  documentNumberRecipient: string;
  documentNumberSender: string;
  electronicBillLadingKey: string;
  enterpriseCode: number;
  enterpriseName: string;
  freightCost: number;
  freightType: string;
  issueDate: string;
  payerCode: string;
  payerCustomerId: string;
  payerCustomerName: string;
  recipientCode: string;
  senderCode: string;
  senderCustomerId: string;
  senderCustomerName: string;
  subsidiary: string;
  subsidiaryName: string;
  serialNumber: string;
  recipientCustomerId: string;
  recipientCustomerName: string;
  transportInvoice: TransportInvoiceProps[];
}

export interface CTeInvoiceState {
  id: string;
  issueDate: string;
  price: number;
  identifier: string;
  documentNumber: string;
  title: string,
  invoiceType: string;
  parcel: string;
  dueDate: string;
  companyName: string;
  balance: number;
  prefix: string;
}

export interface CTeInvoiceItems {
  paidDate: string;
  price: number;
  title: string;
  itemType: string;
  parcel: string;
  dueDate: string;
  prefix: string;
}

export interface CTeStockState {
  id: string,
  unitPrice: number,
  customerId: string,
  customerName: string,
  unitMeasurement: string,
  totalBalance: number,
  warehouse: string,
  productCode: string,
  productDescription: string,
  productGroup: string,
  address: string,
  city: string,
  state: string,
  daysToExpire: number | string,
  daysToExpireLabel?: string;
  integrationUpdatedDate: string;
}

export interface CTeStockItem {
  lot: string,
  balanceAvailable: number,
  dueDate: string,
  manufacturingDate: string,
  identifier: string,
  productDescription: string,
  supplierProductDescription: string,
  supplierProductCode: string,
  daysToExpire: number | string,
}
interface TransportInvoiceProps {
  weight: number,
  price: number,
  size: number,
  invoiceKey: string,
  packing: string,
  productCode: string;
}

interface OptionsType {
  value: string | number;
  label: string;
}

export enum enumLabelExpirationDayStock {
  Ok = 'Ok',
  VENCIMENTO_EM_15_DIAS = 'À vencer 15 dias',
  VENCIMENTO_EM_30_DIAS = 'À vencer 30 dias',
  VENCIMENTO_EM_60_DIAS = 'À vencer 60 dias',
}